import i from "./getOrderFormatAOTipSettings.mjs";
import "@ancon/wildcat-types";
import "./getSettingsForOrderFormat.mjs";
function s(r, e) {
  const t = i(r, e);
  return !!t && (t.aoAllowCustomTipping || t && t.tipPercentages.length > 0);
}
export {
  s as default
};
